import { PiggyBank, Wallet } from "lucide-react";
import { formatCHF } from "@/lib/api";

export const ACOMPTE = 150;

export const ModePaiement = ({ value, onChange, total, testidPrefix, jourLabel = "le jour du stage" }) => {
  if (total <= ACOMPTE) return null;
  const opts = [
    { id: "total", label: "Payer la totalité", detail: `${formatCHF(total)} aujourd'hui`, icon: Wallet },
    { id: "acompte", label: "Acompte maintenant", detail: `${formatCHF(ACOMPTE)} aujourd'hui · solde ${formatCHF(total - ACOMPTE)} au plus tard ${jourLabel}`, icon: PiggyBank },
  ];
  return (
    <div className="grid sm:grid-cols-2 gap-2" role="radiogroup" aria-label="Mode de paiement" data-testid={`${testidPrefix}-mode-paiement`}>
      {opts.map(({ id, label, detail, icon: Icon }) => {
        const active = value === id;
        return (
          <button type="button" key={id} onClick={() => onChange(id)} data-testid={`${testidPrefix}-mode-${id}`}
            className={`flex items-start gap-3 text-left rounded-xl border px-3 py-3 transition-colors duration-300 ${active ? "border-terra bg-terra/5" : "border-wood/20 hover:border-wood/40"}`}>
            <Icon className={`w-4 h-4 shrink-0 mt-0.5 ${active ? "text-terra" : "text-fumee"}`} />
            <span className="min-w-0">
              <span className={`block text-sm font-medium ${active ? "text-earth font-semibold" : "text-bark"}`}>{label}</span>
              <span className="block text-[11px] text-fumee mt-0.5 leading-snug">{detail}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
};
